//@ts-ignore
import React, { Component } from 'react'
import { singleUserAxios } from '../../../services/axios';
import {withRouter} from 'react-router'
import { Country, LoginCaptcha, SelectedCountry, SiteKey, UserDataPass, UserEmail, UserEmpCode, UserErrorV2, UserMobile, VerifyUser } from '../types/LoginRequestV2';
import ReCAPTCHA from 'react-google-recaptcha';
import './../components/LoginV2.css';
import config from '../../../config/config';
import LoginWithOTP from '../components/LoginWithOTP';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import userActionsV2 from '../actions/userActionsV2';
export interface LoginFormProps {
  userVerify: Function,
  history: any,
  refreshCaptcha: any,
  name: string,
  location: any,
  clearErrorMsg: Function,
}
export interface LoginFormState {
  form: VerifyUser,
  isLoginWithOtp: boolean,
  formErrorV2: UserErrorV2,
  countryList: Country[],
  selectedCountry: SelectedCountry,
  isOpenDrop: boolean,
  isCountryShow: boolean,
  withEmail: UserEmail,
  withMobile: UserMobile,
  withEmpCode: UserEmpCode,
  reCaptcha: LoginCaptcha,
  siteKey: SiteKey,
  captchaError:boolean,
  userDataPass: UserDataPass[],
  userType: any,
  isFirstLoginScreen:boolean,
  formType: any,
  captchaShow: boolean,
  captchaChecked: boolean,
  previousData: any,
  fingerprintID: string
}
class LoginV2 extends Component<LoginFormProps, LoginFormState> {
  dataValueRetain: LoginFormProps
  constructor(props: LoginFormProps, state: LoginFormState) {
    super(props)
    this.dataValueRetain = props
    this.state = {
      form: {
        id: '',
        appName: 'authors'
      },
      formErrorV2: {
        id: '',
      },
      countryList: [
        {
          alpha3: 'IND',
          name: 'India',
          dialCode: '+91',
          flag: '/assets/img/singleSignin/country-flags/india.png'
        },
        {
          alpha3: 'BHR',
          name: 'Bahrain',
          dialCode: '+973',
          flag: '/assets/img/singleSignin/country-flags/bahrain.png'
        },
        {
          alpha3: 'QAT',
          name: 'Qatar',
          dialCode: '+974',
          flag: '/assets/img/singleSignin/country-flags/qatar.png'
        },
      ],
      selectedCountry: {
        dialCode: (((this.dataValueRetain.location || {}).state || {}).data || {}).countryCode ? (((this.dataValueRetain.location || {}).state || {}).data || {}).countryCode : '+91',
        flag: (((this.dataValueRetain.location || {}).state || {}).data || {}).countryFlag ? (((this.dataValueRetain.location || {}).state || {}).data || {}).countryFlag : '/assets/img/singleSignin/country-flags/india.png',
      },
      withEmail: {
        appName: 'authors',
        email: '',
        captchaToken: '',
      },
      withMobile: {
        appName: 'authors',
        mobile: '',
        captchaToken: '',
        countryCode:  '',
      },
      withEmpCode: {
        appName: 'authors',
        empCode: '',
        captchaToken: '',
      },
      reCaptcha: {
        loginCaptcha: ''
      },
      siteKey: {
        siteKey: config.captchaKey
      },
      userDataPass: [],
      userType:'',
      formType: '',
      isOpenDrop: false,
      isLoginWithOtp: false,
      isCountryShow: (((this.dataValueRetain.location || {}).state || {}).data || {}).type === 'mobile',
      captchaError: false,
      isFirstLoginScreen: true,
      captchaShow: false,
      captchaChecked: false,
      previousData: ((((this.dataValueRetain.location || {}).state || {}).data || {}).username || ''),
      fingerprintID: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onChangeCountry(this.state.countryList[0]);
    this.handleSubmitWithOTP = this.handleSubmitWithOTP.bind(this);
    this.reCaptcha('');
    this.setState({ siteKey: this.state.siteKey.siteKey });
    this.setState({isLoginWithOtp: false, isFirstLoginScreen: true, captchaShow: false, captchaError: false});
    this.setState({previousData: ((((this.dataValueRetain.location || {}).state || {}).data || {}).username || '')});
    this.props.history.push({pathname: '/login', state: null}); 
  }

  

  

  onChangeCountry = (obj:Country) => {
    this.setState({selectedCountry: obj, isOpenDrop: !this.state.isOpenDrop});
  }

  toggleDropdown() {
    this.setState({isOpenDrop: !this.state.isOpenDrop});
  }

  handleChange(e: any) {
    this.setState({previousData: e.target.value})
    const { name, value } = e.target;
    let form: any = this.state.form;
    form[name] = value;
    this.setState({ form });
    let formErrorV2: UserErrorV2 = {
      id: '',
    }
    this.setState({ formErrorV2 });
    if (e.target.value === '') {
      formErrorV2.id = ''
    }
    //Code for country code show on number type
    const regex = /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/;
    if (isNaN(e.target.value)){
      if (!new RegExp(regex).test(e.target.value)) {
        this.setState({isCountryShow: false});
      }
    } else if (e.target.value.length > 5 && e.target.value.length <= 10) {
      this.setState({isCountryShow: true});
    } else {
      this.setState({isCountryShow: false});
    }
    this.validateEmail(value);
  }

  validateEmail(value: string) {
    if (!value) {
      return;
    }

    let formErrorV2: UserErrorV2 = {
      id: '',
    };

    const emailArray = value.split('@');
    if (emailArray.length >= 2 && (emailArray[0].length > 25 || emailArray[emailArray.length-1].length > 20)) {
      formErrorV2.id = 'Email ID length must not exceed 46 characters';
    }
    this.setState({ formErrorV2 });
  }

  handleSubmit(e: any) {
    localStorage.removeItem(config.localStorageKey);
    localStorage.removeItem('tempAuthToken');
    localStorage.removeItem('backToForgot');
    e.preventDefault();
    let userNameType = '';
    //call to parent method
    const regex = /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/;
    this.state.form.id = this.state.previousData || this.state.form.id.trim();
    let payload = '';
    payload += '?id=' + this.state.form.id,
    payload += '&appName=' + 'authors'
    let formErrorV2: UserErrorV2 = {
      id: '',
    }
    const email = this.state.form.id && this.state.form.id.split('@') || [];
    if (email.length > 1 && (email[0].length > 25 || email[email.length-1].length > 20)) {
      formErrorV2.id = 'Email ID length must not exceed 46 characters';
    } else if (!this.state.form.id) {
      formErrorV2.id = 'Please enter EMP Code / Mobile No / Email ID';
    } else {
      if (isNaN(this.state.form.id)){
        if (!new RegExp(regex).test(this.state.form.id)) {
          formErrorV2.id = 'Invalid Email ID';
        } else {
          userNameType = 'email'
        } 
      } else if (this.state.form.id.length < 5) {
          formErrorV2.id = 'Invalid EMP Code';
        } else if (this.state.form.id.length === 5) {
          userNameType = 'empCode'
        }  else if (this.state.form.id.length > 5 && this.state.form.id.length !== 10){
          formErrorV2.id = 'Invalid Mobile Number';
        } else {
          userNameType = 'mobile'
        }
        if (!this.state.form.id) {
          this.setState({ formErrorV2 });
          return;
        }
        if (this.state.form.id) {
          if(this.state.form.id.length === 5 || this.state.form.id.length === 10 || new RegExp(regex).test(this.state.form.id)) {
            singleUserAxios.get(`v4/verify-user`+payload).then((res: any) => {
            if (res.data.isValidUser) {
              this.props.clearErrorMsg();
              this.props.history.push({pathname: "/login-with-password", data: {
                username: this.state.form.id ? this.state.form.id : this.state.previousData,
                type: userNameType,
                loginVia: 'password',
                countryCode: this.state.selectedCountry.dialCode,
                countryFlag: this.state.selectedCountry.flag,
                isPasswordSet: !res.data.isPasswordSet ? 'false' : 'true',
              }});
              localStorage.setItem('isFirstUser', !res.data.isPasswordSet ? 'true' : 'false')
            } else {
              if (userNameType === 'empCode') {
                formErrorV2.id = 'Invalid EMP Code';
              } else if (userNameType === 'email') {
                formErrorV2.id = 'Invalid Email ID';
              } else if (userNameType === 'mobile') {
                formErrorV2.id = 'Invalid Mobile Number';
              }
              this.setState({ formErrorV2 });
            }
          });
          }
          
        }
      }
      this.setState({ formErrorV2 });
  }

  componentDidMount() {
    this.state.form.id = (((this.dataValueRetain.location || '').state || '').data || '');
    //@ts-ignore
    let userData = JSON.parse(localStorage.getItem("patmy"));
    const isUserLoggedIn = userData && !!(userData.authenticatedUser || {}).authToken;
    const { fingerprintJsKey = '' } = config;
    if(!isUserLoggedIn && fingerprintJsKey){
      let e = document.createElement("script");
      e.text = `var fpPromise = import('https://glorifire.com/ldqqBsym3DsNbIwk/4oK5majU2miiZI0Y?apiKey=${fingerprintJsKey}')
      .then(FingerprintJS => FingerprintJS.load({
        endpoint: [
          "https://glorifire.com/ldqqBsym3DsNbIwk/lHcu0BYHvE9f1V8e?region=ap",
          FingerprintJS.defaultEndpoint
        ],
        region: "ap"
      }))
    fpPromise
      .then(fp => fp.get()).catch((err)=>console.log("err", err))
      .then(result => {
        const visitorId = result.visitorId
        localStorage.setItem('visitorId', visitorId);
        const event = new Event('fingerprintScriptLoaded');
        window.dispatchEvent(event);
      }).catch((err)=>console.log("err", err))`;
      e.type="text/javascript";
      window.addEventListener('fingerprintScriptLoaded', () => {
        const visitorId = localStorage.getItem('visitorId') || '';
        this.setState({fingerprintID: visitorId});
      });
      document.getElementsByTagName("head")[0].appendChild(e);
    }
  }

  // componentDidUpdate() {
  //   if (this.state.reCaptcha === null) {
  //     this.setState({captchaChecked: false})
  //   }
  // }

  captchaGenerate() {
    if (!this.state.captchaChecked) {
      singleUserAxios.get(`v4/show-captcha`).then((res: any) => {
        if (res.data.showCaptcha) {
          this.setState({captchaShow: true, captchaError: true})
        }
      });
    }
  }

  handleSubmitWithOTP(e?: any, fromCaptcha?: any) {
    localStorage.removeItem(config.localStorageKey);
    localStorage.removeItem('backToForgot');
    localStorage.removeItem('tempAuthToken');
    // e.preventDefault();
    if (!fromCaptcha){

      this.captchaGenerate();
    }
    let userNameType = '';
    //call to parent method
    const regex = /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/;
    this.state.form.id = this.state.previousData || this.state.form.id.trim();
    let formErrorV2: UserErrorV2 = {
      id: '',
    }
    if (!this.state.form.id) {
      formErrorV2.id = 'Please enter EMP Code / Mobile No / Email ID';
    } else {
      if (isNaN(this.state.form.id)){
        if (!new RegExp(regex).test(this.state.form.id)) {
          formErrorV2.id = 'Invalid Email ID';
        } else {
          userNameType = 'email'
        } 
      } else if (this.state.form.id.length < 5) {
          formErrorV2.id = 'Invalid EMP Code';
        } else if (this.state.form.id.length === 5) {
          userNameType = 'empCode'
        }  else if (this.state.form.id.length > 5 && this.state.form.id.length !== 10){
          formErrorV2.id = 'Invalid Mobile Number';
        } else {
          userNameType = 'mobile'
        }
        if (!this.state.form.id) {
          this.setState({ formErrorV2 });
          return;
        }
        if (this.state.form.id) {
          let payload = '';
          payload += '?id=' + this.state.form.id,
          payload += '&appName=' + 'authors'
          // SignIn Via Email
          let withEmail: UserEmail = {
            appName: 'authors',
            email: this.state.form.id
          }
          if (typeof this.state.reCaptcha === 'string') {
            withEmail['captchaToken'] = this.state.reCaptcha;
          }
          this.setState({ withEmail });

          // SignIn Via Mobile
          let withMobile: UserMobile = {
            appName: 'authors',
            mobile: this.state.form.id,
            countryCode: this.state.selectedCountry.dialCode
          }
          if (typeof this.state.reCaptcha === 'string') {
            withMobile['captchaToken'] = this.state.reCaptcha;
          }
          this.setState({ withMobile });

          // SignIn Via Mobile
          let withEmpCode: UserEmpCode = {
            appName: 'authors',
            empCode: this.state.form.id
          }
          if (typeof this.state.reCaptcha === 'string') {
            withEmpCode['captchaToken'] = this.state.reCaptcha;
          }
          this.setState({ withEmpCode });
          singleUserAxios.get(`v4/verify-user`+payload).then((res: any) => {
            if (res.data.isValidUser) {
              let data: any = {
                username: this.state.form.id ? this.state.form.id : this.state.previousData,
                type: userNameType,
                loginVia: 'otp',
                isPasswordSet: !res.data.isPasswordSet ? 'false' : 'true',
                countryCode: this.state.selectedCountry.dialCode,
                countryFlag: this.state.selectedCountry.flag,
              }

              if (typeof this.state.reCaptcha === 'string') {
                data['captchaToken'] = this.state.reCaptcha;
              }

              localStorage.setItem('isFirstUser', !res.data.isPasswordSet ? 'true' : 'false')
              if (this.state.captchaShow && !this.state.captchaChecked) {
                this.setState({captchaShow: true, captchaError: true})
              } else {
                if (this.state.reCaptcha === null) {
                  this.setState({captchaChecked: false})
                  this.captchaGenerate();
                } else {
                  if (new RegExp(regex).test(this.state.form.id)) {
                    if (userNameType === 'email') {
                      singleUserAxios.post(`v4/login/send-otp`, withEmail).then((res: any) => {
                        this.props.history.push({pathname: "/login-with-otp", data: {...data, userDataPass: res.data}});
                      })
                    }
                  } else if (userNameType === 'empCode' && this.state.form.id.length === 5) {
                    singleUserAxios.post(`v4/login/send-otp`, withEmpCode).then((res: any) => {
                      this.props.history.push({pathname: "/login-with-otp", data: {...data, userDataPass: res.data}});
                    })
                  } else if (userNameType === 'mobile' && this.state.form.id.length > 5 && this.state.form.id.length === 10){
                      singleUserAxios.post(`v4/login/send-otp`, withMobile).then((res: any) => {
                        this.props.history.push({pathname: "/login-with-otp", data: {...data, userDataPass: res.data}});
                      });
                  }
                }
              }
            } else {
              if (userNameType === 'empCode') {
                formErrorV2.id = 'Invalid EMP Code';
              } else if (userNameType === 'email') {
                formErrorV2.id = 'Invalid Email ID';
              } else if (userNameType === 'mobile') {
                formErrorV2.id = 'Invalid Mobile Number';
              }
              this.setState({ formErrorV2 });
            }
          });
      } 
    }
    this.setState({ formErrorV2 });
  }

  reCaptcha = (value: any) => {
    this.setState({reCaptcha: value, captchaChecked: true, captchaError: false});
    if (value !== ''){
      this.handleSubmitWithOTP('', true);
    }
  }

  render() {
    const { formErrorV2, selectedCountry, siteKey} = this.state;

    return (
      <>
        <div className="login-container">
          <em></em><em></em><em></em><em></em>
          <div className="sign-in-container">
            <img src="/assets/svg/authors-new-logo.svg" className="logoCms" alt="mypat logo" />
            <div className="signin-form">
              <h2 className="mainTitle">
                Hello, Glad to see you!
                <span className="subTitle">Sign in to continue access</span>
              </h2>
              <form onSubmit={this.handleSubmit}>
              <div className="form-group loginPwd">
                <div className={`defaultGrid ${this.state.isCountryShow ? 'flag-container' : ''} ${formErrorV2.id ? 'errorBorder' : ''}`}>
                  {this.state.isCountryShow ? 
                <div className="d-flex">
                    <button className="country-flag dropdown-toggle" type="button" onClick={() => this.toggleDropdown()} data-bs-toggle="dropdown">
                      <img src={selectedCountry.flag} />
                      <span className="country-code">{selectedCountry.dialCode}</span>
                    </button>
                    {this.state.isOpenDrop ? <div  className="dropdown-menu show" id="dropdown">
                    {this.state.countryList.map((option, index) => (
                      <a className="dropdown-item" href="javascript:void(0)" key={index.toString()} onClick={() => this.onChangeCountry(option)}>
                        <img alt={option.name} src={option.flag} />
                        <span className="country-code">{option.dialCode}</span>
                        {option.name}
                      </a>
                    ))}
                    </div> : null
                  }
                  </div> : null }
                  <input
                    type="text" autoComplete='off' ref={(element: any) => element && element.focus()} value={this.state.previousData} name="id" onChange={this.handleChange} className={`inputField ${formErrorV2.id ? 'errorBorder' : ''}`}
                    placeholder="Enter EMP Code, Mobile No or Email ID"
                  />
                </div>
                <div className="error">{formErrorV2.id}</div>
              </div>

              <div className="input-group">
                <button type='submit' className="submit-btn" disabled={!this.state.fingerprintID}>
                  Continue
                </button>
              </div>
              </form>
            </div>
          </div>
          <div className="sign-in-footer">
            <div className="footer-left">
              <p>&copy; Copyright 2024-2025 Edfora. All Rights Reserved</p>
            </div>
            <div className="footer-right">
              <NavLink to={"/terms-of-use"}> Terms of Use </NavLink> 
              <span>|</span> 
              <NavLink to={"/privacy-policy"}>Privacy Policy</NavLink>
              <span>|</span>
              <NavLink to={"/disclaimer"}>Disclaimer</NavLink>
              <span>|</span>
              <NavLink to={"/copyright"}>Copyright</NavLink>
            </div>
          </div>
        </div>
        
        {/* <MyPATLink align="right" variant="body2" to="/login-with-password">login With Password</MyPATLink>
        <div>
          Or
        </div>
        <MyPATLink align="right" variant="body2" to="/login-with-otp">login With OTP</MyPATLink> */}
      </>
    )
  }
}

//@ts-ignore

const mapStateToProps = (state: any) => ({
});

const mapDispatchToProps = {
  clearErrorMsg: userActionsV2.removeError
};
//@ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withRouter(LoginV2));